import { replaceAt, splice, snakeCaseToUpperCase } from 'helpers/helpers';
import { TemplateType } from '../templates/TemplateType';

export const makePath = (type: TemplateType) => `/pdf/${snakeCaseToUpperCase(type)}`;

export function logErrorFE(err: Error) {
  logError('fe.error', 'Error while rendering the PDF template', err);
}

export function logError(key: string, message: string, detail?: Error) {
  /* eslint-disable no-console */
  console.log(`<CUSTOMERRORKEY>${key}<CUSTOMERRORKEY>`); //pdf.error.data
  console.log(`<CUSTOMERRORMSG>${message}<CUSTOMERRORMSG>`);
  detail &&
    console.log(
      `<CUSTOMERRORDETAIL>${detail.stack ? detail.stack : detail.message}<CUSTOMERRORDETAIL>`,
    );
  /* eslint-enable no-console */
}

export function nicerZipInAddress(permanentAddressCompact: string) {
  const zipInAddress = permanentAddressCompact.match(/(\d{5})/);
  if (zipInAddress && zipInAddress[0]) {
    const zip = zipInAddress[0];
    const zipWithSpace = splice(zip, 3, 0, ' ');
    const { index } = zipInAddress;
    return replaceAt(permanentAddressCompact, index!, zipWithSpace);
  }
  return permanentAddressCompact;
}
